import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// リンク項目（車体記録・車体検査成績書）をアンカーとして表示してよい値か
export function isHttpUrl(value: string): boolean {
  return /^https?:\/\/\S+$/.test(value)
}
